import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 21574 21574"
    {...props}
  >
    <defs>
      <style>
        {
          ".str0{stroke:#000;stroke-width:616.388;stroke-linecap:round;stroke-linejoin:round}.fil0{fill:none}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528311944000">
        <path
          d="M308 308h20957v1638H308z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 616.388,
          }}
        />
        <path
          d="M10369 1948s143 8921-6029 11086l546 2672c77 381-190 742-552 745l-250 2c-155 1-279 136-279 302v734c0 169-127 305-283 305h-357c-156 0-283 137-283 305v657c0 168-127 305-283 305h-261c-156 0-283 136-283 305v868h-566v727c0 168-126 304-283 304H575V1904"
          className="fill-none stroke1"
          style={{
            strokeWidth: 616.388,
          }}
        />
        <path
          d="M575 11931s1380 1287 3765 1104M607 13035s1371 1270 3733 871M2969 13995v833M3252 15367c0 168-127 305-283 305s-283-137-283-305 127-305 283-305 283 137 283 305zM8802 1948s218 4536-2915 8093"
          className="fill-none stroke1"
          style={{
            strokeWidth: 616.388,
          }}
        />
        <path
          d="M3074 12851s1121-542 1741-1668M11316 1948s-144 8921 6029 11086l-546 2672c-78 381 190 742 552 745l250 2c154 1 279 136 279 302v734c0 169 127 305 283 305h357c156 0 283 137 283 305v657c0 168 126 305 283 305h261c156 0 283 136 283 305v868h566v727c0 168 126 304 283 304h631V1904"
          className="fill-none stroke1"
          style={{
            strokeWidth: 616.388,
          }}
        />
        <path
          d="M21110 11931s-1380 1287-3765 1104M21078 13035s-1371 1270-3733 871M18716 13995v833M18433 15367c0 168 126 305 283 305 156 0 283-137 283-305s-127-305-283-305c-157 0-283 137-283 305zM13499 5917c421 1319 1124 2790 2299 4125M12883 1948s-38 797 148 1985"
          className="fill-none stroke1"
          style={{
            strokeWidth: 616.388,
          }}
        />
        <path
          d="M18611 12851s-1121-542-1741-1668"
          className="fill-none stroke1"
          style={{
            strokeWidth: 616.388,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
